export default (settings: any) => settings['responsiveView'] * (10 / 60)
